import {
  type authControllerPostLogout,
  getAuthControllerGetAuthQueryKey,
  type SuccessResponseOutput,
  useAuthControllerGetAuth,
  useAuthControllerPostLogout,
  useMiroControllerGetBoards,
} from '@docnboard/rest';
import type {
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';

export const useGetBoards = useMiroControllerGetBoards;

export const useIsAuthorized = useAuthControllerGetAuth;

export const useLogout = <
  TError = SuccessResponseOutput,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerPostLogout>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof authControllerPostLogout>>,
  TError,
  void,
  TContext
> => {
  const queryClient = useQueryClient();

  return useAuthControllerPostLogout({
    mutation: {
      ...options?.mutation,
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: getAuthControllerGetAuthQueryKey(),
        });
      },
    },
  });
};
